import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["body", "check", "checkAll", "checkSub", "row", "getActive"];

  getActive(e) {
    if (e.target.nodeName == "INPUT") {
      const targetForm = e.target.form;
      if (targetForm !== null) {
        var targetInput = targetForm.querySelector("input[name='task[selected_input_id]']");
        targetInput.value = e.target.id;
      }
    }
  }

  connect() {
    if (this.hasCheckAllTarget) {
      this.checkAllTarget.hidden = false;
    }

    const urlString = window.location.href;
    const url = new URL(urlString);
    const focus_input_id = url.searchParams.get("selected_input_id");
    if (focus_input_id) {
      document.getElementById(focus_input_id).focus();
    }
  }

  toggleRow() {
    const count = this.checkTargets.filter((c) => !c.disabled).length;
    const checkedCount = this.checkTargets.filter((c) => c.checked).length;
    this.checkAllTarget.checked = checkedCount === count;
    this.checkAllTarget.indeterminate = checkedCount > 0 && checkedCount < count;
  }

  toggleShadowCheckbox(e) {
    const checkBoxId = e.target.getAttribute("id");
    const checked = e.target.checked;
    const shadowBoxes = document.querySelectorAll(`[data-shadow-checkbox-id="${checkBoxId}"]`);

    shadowBoxes.forEach((check) => {
      if (!check.disabled) {
        check.checked = checked;
      }
    });
  }

  toggleSubCollection(e) {
    const subService = e.target.getAttribute("data-sub-collection");
    const checked = e.target.checked;
    const subBoxes = document.querySelectorAll(`[data-sub-collection="${subService}"]`);
    this.checkElements(subBoxes, checked);
  }

  checkElements(elementsToCheck, checked) {
    const event = new Event("change");

    elementsToCheck.forEach((check) => {
      if (!check.disabled) {
        check.checked = checked;
        check.dispatchEvent(event);
      }
    });
  }

  toggleAll() {
    const checked = this.checkAllTarget.checked;
    this.checkElements(this.checkTargets, checked);
  }
}
